import React from 'react';
import { IProps } from './types';
import { Footer } from '../Footer';
import { Navbar } from '../Navbar/Navbar';

export const Layout: React.FC<IProps> = ({ ...props }) => {
    return (
        <div className="flex min-h-screen flex-col dark:bg-gray-900">
            <Navbar />
            <main className="relative min-h-full flex-1 pb-10">
                {props.children}
            </main>
            <Footer />
        </div>
    )
}